import { mapActions, mapGetters } from 'vuex';
import cookies from 'js-cookie';

import GET_AFFILIATE_QUERY from '~/graphql/queries/GetAffiliate';
import { affiliates } from '~/vanityUrls.json';
import { saveAnonymousProfile } from '~/util';

export default {
  async fetch() {
    await this.getAffiliateData();
  },
  fetchOnServer: false,
  computed: {
    ...mapGetters(['affiliate']),
  },
  methods: {
    ...mapActions(['setAppQuery']),
    async getAffiliateData() {
      const affiliate = cookies.get('affiliate');
      const countryCode = this.$i18n.locale.toUpperCase();
      const vanityUrl = affiliates.find(
        (p) => p.slug === affiliate && p.country.includes(countryCode)
      );
      const vanitySlug = vanityUrl && vanityUrl.slug;
      if (!vanitySlug) {
        return;
      }
      if (this.affiliate) {
        this.setAppQuery(this.affiliate.appQueryParams);
        const couponCode = this.affiliate.appQueryParams?.find(
          (appQuery) => appQuery.key === 'coupon'
        )?.value;
        saveAnonymousProfile({ couponCode });
        return;
      }
      await this.$apollo
        .query({
          query: GET_AFFILIATE_QUERY,
          variables: {
            id: vanitySlug,
            country: countryCode,
          },
        })
        .then(({ data }) => {
          if (data.entry) {
            this.setAppQuery(data.entry.appQueryParams);
            const couponCode = data.entry.appQueryParams?.find(
              (appQuery) => appQuery.key === 'coupon'
            )?.value;
            saveAnonymousProfile({ couponCode });
          }
        })
        .catch((e) => {
          console.error(e.message);
          this.$router.push({
            path: this.localePath('/'),
            query: this.$route.query,
          });
        });
    },
  },
};
